import type { ChannelsInfoResponse } from '../../model/app-state/types.tsx';
import { getChannelsInfoRest } from '../../rest/get-channels-info/index.tsx';

export const getChannelsInfo = async (projectId: string): Promise<ChannelsInfoResponse> => {
	const response = await getChannelsInfoRest(projectId);
	return response;
};
